import React, { Component } from 'react';
// import {Redirect} from 'react-router-dom';

import * as actionCreators from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import ChangePasswordSchema from './ChangePasswordSchema';
import Dialog from '../Dialogs/Dialog';
import auth from '../../api/auth';
import apiHelper from '../../api/apiHelper';
import Spinner from '../Spinner/Spinner';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { Input } from '../FormGroup';

class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onSuccessDialogClose = this.onSuccessDialogClose.bind(this);

    this.state = {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      serverError: '',
      success: false,
      loading: false
    };
  }

  onSubmitHandler(values, { setSubmitting }) {
    var email =
      this.props.CurrentUser && this.props.CurrentUser.unique_name
        ? this.props.CurrentUser.unique_name
        : this.props.userNamePasswordExpired;
    this.setState({ loading: true });
    auth
      .changePassword(
        email,
        values.currentPassword,
        values.newPassword,
        values.newPasswordConfirm
      )
      .then(
        () => {
          setSubmitting(false);
          this.setState({ success: true, loading: false });
        },
        rejectReason => {
          this.setState({
            serverError: apiHelper.parseError(rejectReason),
            loading: false
          });
          setSubmitting(false);
        }
      );
  }
  onSuccessDialogClose() {
    this.props.logout();
    this.props.passwordChangedAction();

    this.props.history.push('/login');
  }

  render() {
    const forcePasswordUpdateTitle = this.props.passwordExpired ? (
      <h4 className="centerText">
        For security reasons, your password must be changed regularly. Please
        set a new password below.
      </h4>
    ) : null;
    const successDialog = this.state.success ? (
      <Dialog
        title="Password Changed"
        message="Your password has been changed"
        onClose={this.onSuccessDialogClose}
      />
    ) : null;

    const serverError =
      this.state.serverError !== '' ? (
        <div
          className="errorMessage"
          style={{
            marginBottom: 10
          }}
        >
          {this.state.serverError}
        </div>
      ) : null;

    const spinner = this.state.loading ? <Spinner /> : null;
    return (
      <React.Fragment>
        {forcePasswordUpdateTitle}
        {spinner}
        <Formik
          initialValues={{
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: ''
          }}
          validationSchema={ChangePasswordSchema}
          onSubmit={this.onSubmitHandler}
        >
          {() => (
            <Form
              className={classNames(
                'changePasswordForm',
                {
                  centerForm: this.props.passwordExpired
                },
                {
                  plainForm: !this.props.passwordExpired
                }
              )}
            >
              <h2>Change Password</h2>
              <Input
                label="Verify Current Password"
                name="currentPassword"
                type="password"
              />
              <Input
                label="New Password"
                name="newPassword"
                type="password"
              />
              <Input
                label="Confirm New Password"
                name="newPasswordConfirm"
                type="password"
              />
              {serverError}
              <div className="button-group">
                <Button type="submit" bsStyle="primary">
                  Update
                </Button>
              </div>
            </Form>
          )}
        </Formik>
        {successDialog}
      </React.Fragment>
    );
  }
}

export default connect(
  state => state.login,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(ChangePasswordForm);
